export * from "./simple-date-format.pipe";
export * from "./shared-pipes.module";
export * from "./truncate.pipe";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/pipes/index.ts